@if (isDisplayed) {
  <div class="drawer-container" role="complementary">
    <div class="drawer-header">
      <div class="drawer-header__left">
            <span>
                {{ selectedDrawer.label }}
            </span>
      </div>
      <div class="drawer-header__right">
        <button mat-icon-button
                (click)="hideDrawer()"
                aria-label="Hide right panel"
                [matTooltip]="'Hide right panel'"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <div class="drawer-body">
      @switch (drawer) {
        @case (DrawerContent.ROUTE) {
          <app-route-assignment></app-route-assignment>
        }
        @case (DrawerContent.MESSAGES) {
          <app-messages></app-messages>
        }
        @case (DrawerContent.OBSERVATION) {
          <app-observations></app-observations>
        }
        @case (DrawerContent.LIVE_VIDEO) {
          <app-live-video></app-live-video>
        }
        @case (DrawerContent.ALERTS) {
          <app-alerts></app-alerts>
        }
        @case (DrawerContent.QUICK_INSIGHTS) {
          <app-quick-insights></app-quick-insights>
        }
      }
    </div>
  </div>
}

